module.exports = __webpack_public_path__ + "img/73.4.NH3-N.ea07fb4b.png";